import Box from '@material-ui/core/Box';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React__default from 'react';

const styles = (theme) => createStyles({
  root: {
    color: theme.palette.common.white,
    padding: theme.spacing(2, 2, 3),
    backgroundImage: theme.getPageTheme({ themeId: "card" }).backgroundImage,
    backgroundPosition: 0,
    backgroundSize: "inherit"
  }
});
const useStyles = makeStyles(styles, { name: "BackstageItemCardHeader" });
function ItemCardHeader(props) {
  const { title, subtitle, children } = props;
  const classes = useStyles(props);
  return /* @__PURE__ */ React__default.createElement(Box, { className: classes.root }, subtitle && /* @__PURE__ */ React__default.createElement(Typography, { variant: "subtitle2", component: "h3" }, subtitle), title && /* @__PURE__ */ React__default.createElement(Typography, { variant: "h6", component: "h4" }, title), children);
}

export { ItemCardHeader };
//# sourceMappingURL=ItemCardHeader.esm.js.map
